export default "__VITE_ASSET__C9h1q6zH__"